import { Pipe, PipeTransform } from '@angular/core';
import { Address as Adress } from '@mocca-technologies/model';

@Pipe({ name: 'formatAdress' })
export class FormatAdressPipe implements PipeTransform {
    transform(address: Adress): string {
      if (!address) {
        return '<i>No address specified</i>';
      }

      const parts = [];

      if (address.street) {
        let streetPart = address.street;
        if (address.postalCode) {
          streetPart += ' ' + address.postalCode;
        }
        parts.push(streetPart);
      }

      if (address.municipality) {
        parts.push(address.municipality);
      }

      if (address.region) {
        parts.push(address.region);
      }

      if (address.country) {
        parts.push(address.country);
      }

      return parts.length > 0 ? parts.join(', ') : '<i>Address incomplete</i>';
    }
}
